<template>
<div class="chapter">
<div class="inner_page">
<p><a id="als"></a></p>
<div class="fmhT">ALSO BY THE SAME AUTHOR</div>
<div class="ctag1"><i>No Angel</i> <br/><i>Something Dangerous</i> <br/><i>Into Temptation</i> <br/><i>The Dilemma</i> <br/><i>An Outrageous Affair</i> <br/><i>Sheer Abandon</i> <br/><i>An Absolute Scandal</i> <br/><i>Forbidden Places</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590207949_oeb_als_r1.vue?05f447f8